import { useState } from "react";
import { toast } from "sonner";
import { Loader2, QrCode } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function MercadoPagoPay({ planId = "pro" }) {
  const [loading, setLoading] = useState(false);
  const pay = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/mercadopago/preference", { plan_id: planId });
      window.location.assign(data.init_point);
    } catch (e) { toast.error(errMsg(e)); setLoading(false); }
  };
  return (
    <div data-testid="mercadopago-pay">
      <button data-testid={`mp-pay-btn-${planId}`} onClick={pay} disabled={loading}
        className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[#009ee3] px-5 text-sm font-bold text-white transition-colors hover:bg-[#0089c7] disabled:opacity-60">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        {loading ? "Abrindo Mercado Pago..." : "Pagar com Pix"}
      </button>
      <p className="mt-2 flex items-center justify-center gap-1 text-xs text-slate-500" data-testid="mp-pix-only-label"><QrCode className="h-3.5 w-3.5" /> Pagamento via Pix, aprovado na hora</p>
    </div>
  );
}
